import type { LoaderFunction, MetaFunction } from '@remix-run/node';
import { json, redirect } from '@remix-run/node';

import type { LoaderData as RecsLoaderData } from '~/hooks/useRecommendations';
import remixI18n from '~/i18next.server';
import Page from '~/pages/recommendations/Index';
import { getBoostedRecommendations } from '~/services/api/boosted_recommendations/index.server';
import { getRecommendations } from '~/services/api/recommendations/index.server';
import { getPage } from '~/services/api/utils/searchParams.server';
import getCanonicalUrl from '~/utils/getCanonicalUrl';
import getMergedMetaData from '~/utils/getMergedMetaData';

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const metaTitle = data?.metaTitle;

  return getMergedMetaData({
    canonicalUrl: getCanonicalUrl(data?.requestUrl),
    matches,
    returnEarlyCheck: !metaTitle,
    overrides: {
      robots: 'noindex',
      title: metaTitle,
    },
  });
};

export const loader: LoaderFunction = async ({ request }) => {
  // TODO: Refactor these requests to be fetched in parrallel and add publication so we can set the proper language
  const { recommendations: boostedRecommendations } = await getBoostedRecommendations({ request });
  const { recommendations, pagination } = await getRecommendations({
    request,
    page: getPage(request) || 1,
  });
  const url = new URL(request.url);

  const locale = 'en';
  const t = await remixI18n.getFixedT(locale, 'common');

  const noRecommendations =
    pagination.page === 1 && recommendations.length === 0 && boostedRecommendations.length === 0;

  if (noRecommendations) return redirect('/');

  return json<RecsLoaderData>({
    boostedRecommendations,
    recommendations,
    requestUrl: url.href,
    pagination,
    metaTitle: t('meta.titles.recommendations') || 'Recommendations',
  });
};

export default Page;
